import {getFromBookingApi, postToBookingApi} from "@/utilities/fetchUtils";

export function backendFetch(widgetId:number,addressPath:string, type  = 'GET', contentType?:string, content?: string) {
    const path = widgetId + '/' + addressPath;
    if (type === 'GET') {
        return getFromBookingApi(path)
    } else {
        if (!content) {
            throw new Error('Content is required');
        }
        return postToBookingApi(path, content, contentType)
    }
}